import React, { useContext, useEffect } from 'react';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import { Brightness4, Brightness6 } from '@mui/icons-material';
import { ThemeContext } from '../../lib/contexts';
import { getUrlParam } from '../../lib/helpers/helpers';
import { ModeContext } from '../../lib/contexts/ModeContext';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';

const AdminViewToggle = () => {
  const {
    state: { adminView },
    actions: { toggleAdminView },
  } = useContext(ModeContext);
  const navigate = useNavigate();
  const {
    state: { darkMode },
  } = useContext(ThemeContext);

  return (
    <Tooltip
      placement="bottom"
      title={adminView ? 'Patient view' : 'Admin view'}
      aria-label={adminView ? 'Patient view' : 'Admin view'}
    >
      <Typography
        color="textSecondary"
        gutterBottom
        sx={{ display: 'flex', justifyContent: 'flex-end', mr: 4, mt: 1 }}
      >
        <FormControlLabel
          labelPlacement={'start'}
          control={
            <>
              {/* {adminView ? 'Admin View' : 'Patient View'} */}
              {adminView ? (
                <AdminPanelSettingsIcon sx={{ color: darkMode ? 'white' : 'black' }} />
              ) : (
                <PersonIcon sx={{ color: darkMode ? 'white' : 'black' }} />
              )}
              &nbsp;
              <Switch
                checked={adminView}
                size={'small'}
                onChange={() => {
                  const newAdminView = !adminView;
                  toggleAdminView();
                  // if(!newAdminView){
                  //     navigate('/resume')
                  // }
                }}
              />
            </>
          }
          label={''}
        />
      </Typography>
    </Tooltip>
  );
};
export default AdminViewToggle;
